import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let auxApiPromise: Promise<AxiosInstance> | null = null;
export const getAuxApi = async () => {
  if (auxApiPromise) return auxApiPromise;

  auxApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return auxApiPromise;
};

export interface AuxEntity {
  id: number;
  nombre: string;
}

export interface GetRelationFieldSectionProps {
  nombre?: string;
}

export const getListadoHobbies = async (
  props: GetRelationFieldSectionProps,
) => {
  const api = await getAuxApi();

  if (!api) return null;
  const response = await api.get(
    `/Auxiliares/Hobbies?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const getListadoProfesiones = async (
  props: GetRelationFieldSectionProps,
) => {
  const api = await getAuxApi();

  if (!api) return null;
  const response = await api.get(
    `/Auxiliares/Profesiones?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export const getListadoNivelesEstudio = async () => {
  const api = await getAuxApi();

  if (!api) return null;
  const response = await api.get("/Auxiliares/NivelesEstudio");
  return response.data;
};

export const getListadoEstadosCiviles = async () => {
  const api = await getAuxApi();

  if (!api) return null;
  const response = await api.get("/Auxiliares/EstadosCiviles");
  return response.data;
};

export const getListadoSexosBiologicos = async () => {
  const api = await getAuxApi();

  if (!api) return null;
  const response = await api.get("/Auxiliares/SexosBiologicos");
  return response.data;
};

export interface GetMotivosProps {
  esRechazo?: boolean;
  idTipoSolicitud?: number;
}

export const getMotivos = async (props: GetMotivosProps) => {
  const api = await getAuxApi();
  if (!api) return null;
  const response = await api.get(
    `/Auxiliares/GetMotivos?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export const getListadoGranos = async () => {
    const api = await getAuxApi();
  if (!api) return null;
  const response = await api.get(
    `/Auxiliares/Granos`,
  );

  return response.data;
}